import React from "react";
import { Link } from "react-router-dom";
import lazySizes from "lazysizes";
import styled from "styled-components/macro";
import { GiFilmSpool } from "react-icons/gi";

export default function Poster({ poster_url, slug }) {
  return (
    <PosterLink to={`/movie/${slug}`}>
      {poster_url ? (
        <PosterImage data-src={poster_url} className="lazyload" />
      ) : (
        <NoPoster>
          <GiFilmSpool />
        </NoPoster>
      )}
    </PosterLink>
  );
}

const PosterLink = styled(Link)`
  display: flex;
  height: 100%;
`;

const PosterImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 0.25rem;
  border: 1px solid rgba(var(--color-blue-rgb), 0.375);
  object-fit: cover;
`;

const NoPoster = styled.div`
  object-fit: cover; // ?
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  width: 100%;
  height: 100%;
  border-radius: 0.25rem;
  border: 1px solid rgba(var(--color-blue-rgb), 0.375);
  background: whitesmoke;
  color: var(--color-blue);
  opacity: 0.75;
`;
